// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pizX","comment":"styles_comment__39ZtM"};